<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item href="" @click.native="() => $router.go(-1)"
        >上一页</a-breadcrumb-item
      >
      <a-breadcrumb-item>确认预约</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="content">
      <div class="flex">
        <div class="hospital-info">
          <div class="list-item">
            <h3>预约信息</h3>
            <!--预约挂号-->
            <div
              class="list-item-content"
              v-if="$route.query.type != 'physical'"
            >
              <div>就诊校区：{{ dataInfo.yqmc }}</div>
              <div>预约科室：{{ dataInfo.ghksmc }}</div>
              <div>预约医生：{{ dataInfo.ygxm || "普通门诊" }}</div>
              <div>
                就诊日期：<span class="fontColor"
                  >{{ dataInfo.gzrq }} {{ dataInfo.sourceTime }}</span
                >
              </div>
              <div>
                序号：<span class="fontColor"
                  >{{ dataInfo.sourceSeria }}号</span
                >
              </div>
              <div>
                挂号费用：<span class="fontColor"> {{ dataInfo.ghf }}元 </span>
              </div>
            </div>

            <!--体检预约-->
            <div class="list-item-content" v-else>
              <div>就诊院区：{{ physicalParams.campusName }}</div>
              <div>预约套餐：{{ physicalParams.comboName }}</div>
              <div>
                就诊日期：<span class="fontColor"
                  >{{ physicalParams.dateStr }}
                  {{ physicalParams.allotTimePeriod }}
                </span>
              </div>
              <div class="flex-start">
                <span class="no-warp">备注：</span>
                <a-textarea
                  v-model="remark"
                  class="textarea"
                  placeholder=""
                  :rows="4"
                />
              </div>
            </div>
          </div>
        </div>

        <!--体检预约-自选套餐-->
        <div
          class="hospital-info"
          v-if="$route.query.type == 'physical' && isConfirm"
        >
          <div class="list-item">
            <h3>自选套餐</h3>
            <a-form label-width="80px">
              <a-form-item label="">
                <a-select
                  show-search
                  v-model="additionalCombo"
                  placeholder="请选择"
                >
                  <a-select-option
                    v-for="item in selfPackOptions"
                    :key="item.id"
                    :label="item.comboName"
                    :value="item.id"
                  >
                    {{ item.comboName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-form>
          </div>
        </div>

        <!--就诊人信息-->
        <div class="people-info" v-if="$route.query.type != 'physical'">
          <div class="list-item">
            <h3 class="clearfix">
              就诊人信息<i @click="getMoreUser()">切换就诊人</i>
            </h3>
            <div class="list-item-content">
              <div>就诊人：{{ patientInfo.patientName }}</div>
              <div>证件号：{{ patientInfo.idCard }}</div>
              <div>手机号：{{ patientInfo.phone }}</div>
            </div>
          </div>
        </div>

        <div class="people-info" v-else>
          <div class="list-item">
            <h3 class="clearfix">就诊人信息</h3>
            <div class="list-item-content">
              <div>就诊人：{{ userInfo1.name }}</div>
              <div>证件号：{{ userInfo1.idNumber }}</div>
              <div>手机号：{{ patientInfo.phone }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="select" v-if="$route.query.type == 'physical'">
        <h3>请选择可选项目</h3>
        <div class="flex-e">
          <div class="flex-e-l">
            <h3>多选</h3>
            <div v-if="plainOptions.length > 0">
              <a-checkbox-group
                v-model="value"
                name="checkboxgroup"
                :options="plainOptions"
                @change="onChange"
              />
            </div>
          </div>
          <div class="flex-e-r">
            <h3>单选</h3>
            <div v-if="options.length > 0">
              <a-radio-group v-model="value2">
                <a-radio
                  :value="item"
                  v-for="item in options"
                  :key="item"
                  @click="onChange2(item)"
                >
                  {{ item }}
                </a-radio>
              </a-radio-group>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="center">
      <!-- <div class="inform">
        挂号前请仔细阅读<a
          @click="
            () => {
              $router.push('/registrationInfo')
            }
          "
          >《预约须知》</a
        >
      </div> -->
      <a-button type="primary" size="large" @click="onSubmit">
        提交预约
      </a-button>
    </div>
    <!--切换就诊人-->
    <a-modal v-model="visible" title="切换就诊人" width="50%" :footer="false">
      <a-button class="editable-add-btn" @click="handleAdd"> 新增 </a-button>
      <a-table
        bordered
        :columns="columns"
        :data-source="listPatient"
        :pagination="false"
      >
        <template slot="action" slot-scope="text, record">
          <a href="javascript:;" @click="selectItem(text)">选择</a>
        </template>
      </a-table>
    </a-modal>

    <!--自选套餐说明-->
    <a-modal
      title="浙大教职工体检新计划！科技与关怀同行，共筑健康未来"
      v-model="isShowTip"
      width="600px"
      :maskClosable="false"
      :closable="false"
      centered
    >
      <div class="tip-content">
        <div class="content-box">
          <h6>一、项目简介</h6>
          <p>
            为促进浙大教职员工的身心健康，浙江大学公共卫生学院与校医院共同合作，依托“健康浙江”百万人群队列，为浙大教职工体检开启免费升级计划，致力于提供更全面、科学的教师健康管理体系，开展大数据驱动的重大慢病“早预防-早发现-早诊断-早治疗-精准治疗-预后监控-健康管理”全链条的精准健康服务。为每一位自愿参与项目，提供血尿等生物样品、填写调查问卷的教职员工，进行免费的附加体检服务和健康管理服务，从而帮助浙大教职工构建起个体和群体的精准健康画像，发现疾病的高危因素，及时采取干预措施。
          </p>
        </div>
        <div class="content-box">
          <h6>二、参加这个项目您的获益？</h6>
          <p>
            1、一份重大慢病（心脑血管病、肿瘤、认知障碍等）风险预测/评估报告
          </p>
          <p>2、一份生物学年龄检测报告和膳食营养评估报告</p>
          <p>
            3、对高危人群提供相关的健康管理指导，制定更科学的生活方式和健康计划
          </p>
        </div>
        <div class="content-box">
          <h6>三、怎么参加这个项目?</h6>
          <p>1、在浙大钉预约体检时，选择同意参与项目</p>
          <p>2、在体检现场签署知情同意书</p>
          <p>3、采集血液样本、粪便样本、尿液样本</p>
          <p>4、填写调查问卷(约20-25 分钟)</p>
        </div>
        <div class="content-box">
          <p>
            此调查问卷包括饮食、职业、生活方式、抽烟/饮酒、体育锻炼、疾病史等，我们会保护您个人隐私资料的数据安全。
          </p>
        </div>
        <div class="content-box">
          <p>
            如您参加此项目，请点击<strong>确认参加</strong>，如不参加此项目请点击<strong
              >放弃</strong
            >
          </p>
        </div>
      </div>
      <template slot="footer">
        <a-button key="back" @click="onGiveUp"> 放 弃 </a-button>
        <a-button key="submit" type="primary" @click="confirmAttendance">
          确认参加
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import base from "@/assets/base/base.js";
import { submitOppointment } from "@/api/registration";
import {
  getReserveAdd,
  getMemberUser,
  getComboTypeTipFlag,
  getAdditionalComboList,
} from "@/api/medicalBooking";
import { getListPatients } from "@/api/bac";
export default {
  components: {},
  data() {
    return {
      selfPackOptions: [],
      additionalCombo: "",
      isConfirm: false,
      isShowTip: false,

      visible: false,
      listPatient: [], //就诊人
      columns: [
        {
          title: "姓名",
          dataIndex: "name",
          width: 100,
        },
        {
          title: "手机号",
          dataIndex: "phone",
          width: 200,
        },
        {
          title: "证件号",
          dataIndex: "idNumber",
          width: 200,
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          scopedSlots: { customRender: "action" },
        },
      ],
      plainOptions: [],
      options: [],
      value: [],
      value2: "",
      remark: "",
      dataInfo: {},
      patientInfo: {
        idCard: "",
        patientName: "",
        phone: "",
      },
      type: "",
      physicalParams: {},
      userInfo1: {},
    };
  },
  watch: {
    "$route.query": {
      handler(val) {
        const data = val.data && JSON.parse(val.data);
        this.dataInfo = data;

        if (val.type) {
          this.type = val.type;
        }
        if (val.physicalParams) {
          this.physicalParams = JSON.parse(val.physicalParams);

          // if (this.physicalParams.optionalItemCheckbox) {
          //   this.plainOptions =
          //     this.physicalParams.optionalItemCheckbox.split(",");
          //   this.value = this.plainOptions;
          // }
          // if (this.physicalParams.optionalItemRadio) {
          //   this.options = this.physicalParams.optionalItemRadio.split(",");
          //   this.value2 = this.options[0];
          // }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    this.isBW=sessionStorage.getItem("isBW");
    
    const userInfo =
      sessionStorage.getItem("userInfo") &&
      JSON.parse(sessionStorage.getItem("userInfo"));

    //个人信息
    this.patientInfo = {
      ...userInfo,
      age: userInfo.birthday ? base.sumAge(userInfo.birthday) : 0,
      idCard:
        userInfo.certificateType === "0" ? userInfo.idCard : userInfo.passport,
      patientName: userInfo.userName,
      phoneNumber: userInfo.phone,
    };

    await this.getMemberUserInfo();
    await this.getALLUserList(userInfo.userNo);
  },
  methods: {
    //放弃
    onGiveUp() {
      this.isShowTip = false;
      this.isConfirm = false;
    },
    //确认参加
    confirmAttendance() {
      this.isShowTip = false;
      this.isConfirm = true;
      this.getSelfPackOptionsList();
    },
    //获取自选套餐状态
    async getSelfPackStatus() {
      let params = {
        type: "3",
      };
      let { code, data } = await getComboTypeTipFlag(params);
      if (code == 200) {
        this.status = data && data.status;
        if (this.status == "1" && this.isBW) {
          //展示自选套餐说明
          let that = this;
          this.$confirm({
            title: "提示",
            content: "去年是否已参加百万队列项目？",
            okText: "已参加",
            cancelText: "未参加",
            onOk() {
              //去年参加过，就不能选择自选套餐
              that.isShowTip = false;
              sessionStorage.setItem("isBW", false);
              that.isBW=false;
              that.additionalCombo="";
            },
            onCancel() {
              //没参加过，展示提示
              that.isShowTip = true;
            },
          });
        } else {
          this.isShowTip = false;
          this.additionalCombo="";
          this.selfPackOptions = [];
        }
      }
    },

    //获取自选套餐
    async getSelfPackOptionsList() {
      let applyPersonnelType = "";
      //人员类型 1-在职 2-在校学生 3-退休 4-校外人员 5-其他
      if (this.userInfo1.memberType == 1) {
        applyPersonnelType = "在职";
      } else if (this.userInfo1.memberType == 2) {
        applyPersonnelType = "在校学生";
      } else if (this.userInfo1.memberType == 3) {
        applyPersonnelType = "退休";
      } else if (this.userInfo1.memberType == 4) {
        applyPersonnelType = "校外人员";
      } else if (this.userInfo1.memberType == 5) {
        applyPersonnelType = "其他";
      }

      let params = {
        applyCampus: this.physicalParams.campusName,
        applyPersonnelType,
        genderRestrictions: this.userInfo1.gender,
        applyTitle: this.userInfo1.title,
        age: this.userInfo1.age,
        marriageRestrictions: this.userInfo1.maritalStatus, //婚姻状况
        pageNum: 1, //页码 默认为1
        pageSize: 99999, //每页记录数
      };
      let { code, data } = await getAdditionalComboList(params);
      if (code == 200) {
        this.selfPackOptions = data || [];
      }
    },
    handleAdd() {
      this.$router.push({
        path: "/myRegistration",
        query: { queryActived: 7 },
      });
    },
    //选择就诊人
    selectItem(item) {
      this.patientInfo = {
        ...item,
        age: item.birthday ? base.sumAge(item.birthday) : 0,
        certificateType: item.cardType,
        idCard: item.idNumber,
        patientName: item.name,
        phoneNumber: item.phone,
      };
      this.visible = false;
    },
    //切换就诊人
    getMoreUser() {
      this.visible = true;
    },
    //获取就诊人
    async getALLUserList(userNo) {
      let params = {
        userNo,
      };
      let { code, data } = await getListPatients(params);
      if (code == 200) {
        this.listPatient = data;
      }
    },
    /**名单 */
    async getMemberUserInfo() {
      const params = {
        ...this.patientInfo,
      };
      const { code, data } = await getMemberUser(params);
      if (code == 200) {
        if (data) {
          this.userInfo1 = data;

          //上半年逻辑
          // if (
          //   this.userInfo1.title == "高职" &&
          //   this.physicalParams.type == 0 &&
          //   (this.physicalParams.campusId == 10215 ||
          //     this.physicalParams.campusId == 10393)
          // ) {
          //   //获取自选套餐状态
          //   this.getSelfPackStatus();
          // }

          //下半年逻辑
          if (
            this.userInfo1.title == "普教" &&
            this.physicalParams.type == 0 &&
            (this.physicalParams.campusId == 10215 ||
              this.physicalParams.campusId == 10393)
          ) {
            //获取自选套餐状态
            this.getSelfPackStatus();
          }
        } else {
          this.userInfo1 = {};
        }
      }
    },
    onChange(checkedValues) {},
    onChange2(e) {
      this.value2 = this.value2 === e ? "" : e;
    },
    async onSubmit() {
      //预约挂号
      if (this.type !== "physical") {
        const params = {
          sourceId: this.dataInfo.sourceId,
          sourceTime: this.dataInfo.sourceTime,
          expense: base.encryptAES(this.dataInfo.ghf), //挂号费加密
          campusName: this.dataInfo.yqmc.replace("校区", "院区"), //院区名称
          campusId: this.dataInfo.yqdm, //院区编号
          date: this.dataInfo.gzrq, //日期
          doctorId: this.dataInfo.ygdm,
          doctorName: this.dataInfo.ygxm,
          positional: this.dataInfo.ygzc, //职称
          dutyType: this.dataInfo.zblb, //值班类别 1-上午 2-下午
          officeId: this.dataInfo.ghks, //挂号科室编号
          officeName: this.dataInfo.ghksmc,
          organizationId: "1001",

          ...this.patientInfo,
        };

        const { code, data } = await submitOppointment(params);
        if (code == 200) {
          console.log(data);
          this.$router.push({
            path: "/successful",
            query: {
              myRegistrationActived: 0,
              passwordNumber: data.passwordNumber,
              baseInfo: JSON.stringify(params),
            },
          });
        }
      } else {
        //体检预约
        // let selectArr = [];
        // if (this.value.length > 0) {
        //   selectArr.push(...this.value);
        // }
        // if (this.value2) {
        //   selectArr.push(this.value2);
        // }

        //基础项目
        let basicsItem = "";
        if (this.physicalParams.basicsItemList.length > 0) {
          basicsItem = this.physicalParams.basicsItemList
            .map((v) => v.itemName)
            .join();
        } else {
          basicsItem = this.physicalParams.basicsItem;
        }

        const params = {
          name: this.userInfo1.name, //姓名
          userNo:sessionStorage.getItem('userInfo')?JSON.parse(sessionStorage.getItem('userInfo')).userNo:"",
          certificateType: this.userInfo1.certificateType, //证件类型 0-身份证号 1-护照 8-港澳台通行证
          idNumber: this.userInfo1.idNumber, //证件号
          gender: this.userInfo1.gender, //性别 1男 2女
          birthday: this.userInfo1.birthday, //出生日期 yyyy-MM-dd
          age: this.userInfo1.age, //服务年龄
          phone: this.patientInfo.phone, //手机号码用个人信息的
          comboNo: this.physicalParams.id, //套餐编号
          comboName: this.physicalParams.comboName, //套餐名称
          appointmentTime: `${this.physicalParams.dateStr}`, //预约时间 yyyy-MM-dd HH:mm:ss
          campusName: this.physicalParams.campusName, //体检院区
          allotUniqueKey: this.physicalParams.allotUniqueKey, //放号标识
          basicsItem, //基础项目
          selectItem: "", //可选项目
          timePeriod: this.physicalParams.allotTimePeriod,
          comboGenderRestrictions: this.physicalParams.genderRestrictions, //性别限制,1-男，2-女，3-不限
          campusNo: this.physicalParams.campusNo,
          unit: this.userInfo1.unit, //单位
          dept: this.userInfo1.dept, //部门
          jobNumber:
            this.userInfo1.employeeNumber || this.userInfo1.retirementNumber, //工号
          title: this.userInfo1.title,
          type: 0, //预约类型 0-手动预约(用户)、2-手动预约(名单)
          remark: this.remark, //备注
          comboTitle: sessionStorage.getItem("comboTitle"),
          additionalCombo: this.additionalCombo, //自选套餐
        };
        const { code, data } = await getReserveAdd(params);
        if (code == 200) {
          const queryData = {
            ...this.physicalParams,
            ...params,
          };
          this.$router.push({
            path: "/successful",
            query: {
              baseInfo: JSON.stringify(queryData),
              myRegistrationActived: 1,
            },
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-e {
  display: flex;
  justify-content: space-around;
  &-l {
    width: 50%;
  }
  &-r {
    width: 50%;
  }
}
.select {
  box-sizing: border-box;
  border: 1px solid #ebebeb;
  padding: 20px;
}
.content {
  margin-top: 20px;
}

.flex-start {
  display: flex;
  justify-content: flex-start;

  .textarea {
    flex: 1;
    resize: none;
  }
}

.fontColor1 {
  color: #fe695c;
  font-size: 14px;
}

.fontColor {
  color: #3f86ff;
  font-size: 14px;
}

.fontstyle {
  font-size: 14px;
  cursor: pointer;
}

.center {
  margin-top: 52px;
  text-align: center;

  .inform {
    margin: 12px 0;
  }
}

.flex {
  display: flex;
  justify-content: space-evenly;
}

.container {
  .hospital-info,
  .people-info {
    width: 35%;
    margin-right: 10px;
    background-color: #ffffff;
    box-sizing: border-box;
    border: 1px solid #ebebeb;

    .list-item {
      background-color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      padding: 20px;

      h3 {
        font-size: 16px;
        padding-left: 16px;
        i {
          float: right;
          color: #3f86ff;
          cursor: pointer;
        }
      }

      .list-item-content {
        padding: 0px 40px 00px;

        > div {
          margin: 5px 0;
          font-size: 14px;
        }
      }
    }
  }
}
.editable-add-btn {
  margin-bottom: 10px;
}

.content-box {
  margin-bottom: 10px;
  h6 {
    font-weight: bold;
    margin-bottom: 10px;
  }
  strong {
    color: red;
    font-weight: bold;
  }
}
</style>
